import React, { useEffect } from "react";
import { motion, AnimatePresence } from 'framer-motion';
const Functional = () => {

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    //------------------------------------
    // JSX
    //------------------------------------
    return (
      <div>
        <main>
          <AnimatePresence mode="wait">
              <motion.div
                key="functional-view"
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 40 }}
                transition={{ duration: 0.4 }}
              >
                {/* #Hero Section */}
                <section id="functional" className="section overlay tint-black-50 height-40vh">
                  <div className="section__content">
                    <h2 className="general-title">Functional Fitness Program</h2>
                    <h2 className="font-size-20 color-gray-3">
                      high intensity, big results, huge fun!
                    </h2>
                  </div>
                </section>

                {/* #About the Program */}
                <section className="section bg-color-gray-12 noheight padding-bottom-100">
                  <div className="section__content margin-top-140">
                    <div className="gdiv width-80 gap-10px">
                      <h2 className="general-title text-align-left move-left text-shadow">
                        About the Program
                      </h2>
                      <div className="general-description text-align-left move-left text-shadow margin-top-20">
                        <p>
                          The program is based on <strong>high-intensity functional training</strong> workouts. You will work on both <strong>cardio (aerobic)</strong> and <strong>strength (anaerobic)</strong> exercises in a single workout. Different muscle groups are targeted using the body's natural movement patterns.
                        </p>
                        <p className="margin-top-20">
                          Most are <strong>30 to 45-minute</strong> workouts designed to be varied, intense, and <strong>sooo much fun!</strong> <span className="emoji">😁</span>
                        </p>
                        <p className="margin-top-20">
                          The only equipment you need is a <strong>dumbbell</strong> and a <strong>kettlebell</strong>. If you have a jump rope, even better! You can do them from home or at the gym. And we have variations if you have more equipment available at the gym.
                        </p>
                      </div>
                    </div>

                    {/* #Intro Program */}
                    <div className="gdiv width-80 gap-10px margin-top-100">
                      <h2 className="general-title text-align-left move-left text-shadow">
                        🏁 Intro Program
                      </h2>
                      <div className="general-description text-align-left move-left text-shadow margin-top-20">
                        <p>
                          New to functional fitness? No problem! The <strong>Intro Program</strong> is designed specifically for beginners. You'll learn the foundational movements, build confidence, and get comfortable with the equipment — all at your own pace.
                        </p>
                        <p className="margin-top-20">
                          Each workout builds on the previous one, so you progress naturally. By the end, you'll be ready to take on any challenge we throw at you!
                        </p>
                      </div>
                      <button className="button-2 move-left margin-top-30">
                        Get the Intro Program
                      </button>
                    </div>

                    {/* #Xplosive Program */}
                    <div className="gdiv width-80 gap-10px margin-top-100">
                      <h2 className="general-title text-align-left move-left text-shadow">
                        💥 Xplosive Program
                      </h2>
                      <div className="general-description text-align-left move-left text-shadow margin-top-20">
                        <p>
                          Ready to take it to the next level? The <strong>Xplosive Program</strong> is for those who want to push their limits. Higher intensity, complex movements, and maximum effort — this is where the real gains happen.
                        </p>
                        <p className="margin-top-20">
                          Expect explosive movements, advanced combinations, and workouts that will leave you drenched in sweat but hungry for more. This is not for the faint of heart!
                        </p>
                      </div>
                      <button className="button-2 move-left margin-top-30">
                        Get the Xplosive Program
                      </button>
                    </div>

                  </div>
                </section>

              </motion.div>
          </AnimatePresence>
        </main>
      </div>
    );
    
};

export default Functional;
